export default __webpack_public_path__ + "static/media/mi.33776149.jpg";